import { render, staticRenderFns } from "./EducationEntryDegree.vue?vue&type=template&id=56a97686&"
import script from "./EducationEntryDegree.vue?vue&type=script&lang=js&"
export * from "./EducationEntryDegree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports